module.exports = __webpack_public_path__ + "bd180baffe3cff9ac65ddbcffc8841cb.png";